<template>
    <CarConfirmAction :car="car">
        Вы действительно хотите отклонить этот автомобиль?
    </CarConfirmAction>

    <div class="form__content">
        <div class="form-field">
            <UITextArea
                id="comment"
                v-model="form.comment"
                label="Комментарий"
                :error-message="errors.comment?.join() ?? ''"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { Ref } from 'vue';
    import { inject } from '@vue/runtime-core';

    import { Car, CarRejectForm, CarRejectFormErrors } from '@/types/car.type.ts';

    import UITextArea from '@/components/ui/UITextArea/UITextArea.vue';

    import CarConfirmAction from '@/components/cars/CarConfirmAction/CarConfirmAction.vue';

    const { car } = defineProps<{
        car: Car,
    }>();

    const form = inject('form', {}) as Ref<CarRejectForm, CarRejectForm>;
    const errors = inject('errors', {}) as Ref<CarRejectFormErrors, CarRejectFormErrors>;
</script>
